// Shared unicode icon constants

export const ARROW_L = String.fromCodePoint(0x2190)
export const ARROW_R = String.fromCodePoint(0x2192)
export const CHECK = String.fromCodePoint(0x2713)
export const CROSS = String.fromCodePoint(0x2717)
export const CLIP = String.fromCodePoint(0x1F4CE)
export const PDF_ICON = String.fromCodePoint(0x1F4C4)
export const WARN = String.fromCodePoint(0x26A0)
export const CLOCK = String.fromCodePoint(0x23F3)
export const PIN = String.fromCodePoint(0x1F4CD)
export const STOP = String.fromCodePoint(0x23F9)
export const PLAY = String.fromCodePoint(0x25B6)
export const DOWNLOAD = String.fromCodePoint(0x1F4E5)
